import { Controller } from "@hotwired/stimulus"

// Lightweight HTML5 drag-to-reorder. On drop, PATCHes the new id order to
// `urlValue`, which persists positions server-side.
export default class extends Controller {
  static values = { url: String }

  start(event) {
    this.dragged = event.target.closest("[data-sortable-id]")
    event.dataTransfer.effectAllowed = "move"
  }

  over(event) {
    event.preventDefault()
    const target = event.target.closest("[data-sortable-id]")
    if (!target || target === this.dragged) return
    const rect = target.getBoundingClientRect()
    const after = (event.clientY - rect.top) / rect.height > 0.5
    this.element.insertBefore(this.dragged, after ? target.nextSibling : target)
  }

  drop(event) {
    event.preventDefault()
  }

  end() {
    const ids = [...this.element.querySelectorAll("[data-sortable-id]")].map((el) => el.dataset.sortableId)
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    })
  }
}
